export default __webpack_public_path__ + "a600134e5ec8b6ec77911c96e5406793.svg";